
import "bootstrap/dist/css/bootstrap.css";
import * as _ from "underscore";

import { defineComponent } from "vue";

import { reactive, toRefs } from "vue";

import { LinkOutlined } from "@ant-design/icons-vue";

const courses = [
    {
        imgurl: "course_cs73.png",
        number: "COMPSCI 73",
        title: "Code, Data, and Art",
        site: "https://wattenberg.github.io/cs73/",
        desc: "A studio course where software is used as an artistic medium. The course is designed to expose students to current perspectives on the intersection of computer science and art, and to build skills that will allow them to express themselves creatively via software. An additional focus will be the role of data in modern artistic practice.",
        id: "cs73",
    },
    {
        imgurl: "course_hbs.jpg",
        number: "HBS 2135",
        site: "https://www.hbs.edu/coursecatalog/2135.html",
        title: "Data Visualization for Analysis and Communication",
        desc: "A course designed for students who expect to analyze or present data during their career—and these days, data is everywhere, from finance to management consulting. The course will discuss how to critically evaluate visualizations, and how to use them as a bridge between quantitative analysis and decision-making.",
        id: "hbs",
    },
] as any[];

export default defineComponent({
    name: "Courses",
    components: { LinkOutlined },
    setup() {
        const state = reactive({});

        for (let c of courses) {
            c.img = require(`@/assets/images/${c.imgurl}`);
        }

        return {
            courses,
            ...toRefs(state),
        };
    },
    computed: {},
});
